import './App.css';
import React, { Suspense, lazy, useEffect } from 'react';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { getServerInfo } from 'rest_client/apiClient';
import { setWorthwhileNumber } from 'redux/reducers/map';
import theme from 'createTheme';
import { useDispatch } from 'react-redux';
import { Routes, Route } from 'react-router-dom';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Box } from '@mui/material';
import CertificatePdf from 'pages/PublicPage/CertificatePdf';
import FirstLoader from 'components/FirstLoader';
const AdminPage = lazy(() => import('pages/AdminPages'));
const DeleteUser = lazy(() => import('pages/DeleteUser'));
const Layout = lazy(() => import('pages/PublicPage/Layout'));
const Main = lazy(() => import('pages/PublicPage'));
const ThemeProvider = lazy(() => import('@mui/material/styles/ThemeProvider'));
const CustomSnackbar = lazy(() => import('components/CustomSnackbar'));
const Map4MobileApp = lazy(() => import('pages/Map4MobileApp'));
const Debug = lazy(() => import('pages/AdminPages/Debug'));

const queryClient = new QueryClient();

function App() {
  let hostname = window.location.hostname;
  const dispatch = useDispatch();
  const _getServerInfo = async () => {
    try {
      const res = await getServerInfo();
      dispatch(setWorthwhileNumber(res.data.claimchainFnCThreshold));
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    _getServerInfo();
  }, []);

  return (
    <Suspense fallback={<FirstLoader />}>
      <QueryClientProvider client={queryClient}>
        {process.env.REACT_APP_TEST_SV ? (
          <ThemeProvider theme={theme}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <Routes>
                <Route path={'/delete-user'} Component={DeleteUser} />
                <Route path={'/public'} Component={MainApp} />
                <Route path={'/admin/*'} Component={AdminPage} />
                <Route path={'/admin/debug'} Component={Debug} />
                <Route
                  path={'*'}
                  Component={hostname === process.env.REACT_APP_HOST_NAME_PUBLIC ? MainApp : Map4MobileApp}
                />
              </Routes>
            </LocalizationProvider>
            <CustomSnackbar />
          </ThemeProvider>
        ) : hostname === process.env.REACT_APP_HOST_NAME_PUBLIC ? (
          <ThemeProvider theme={theme}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <Routes>
                <Route path={'/delete-user'} Component={DeleteUser} />
                <Route path={'/public'} Component={MainApp} />
                <Route path={'/admin/*'} Component={AdminPage} />
                <Route path={'/admin/debug'} Component={Debug} />
                <Route path={'*'} Component={MainApp} />
              </Routes>
            </LocalizationProvider>
            <CustomSnackbar />
          </ThemeProvider>
        ) : (
          <Map4MobileApp />
        )}
      </QueryClientProvider>
    </Suspense>
  );
}

export default App;

const MainApp = () => (
  <Layout>
    <CustomSnackbar />
    <Box display={{ xs: 'block', md: 'flex' }} height={'100%'} flexDirection={{ xs: 'column', md: 'row' }}>
      <CertificatePdf />
      <Main />
    </Box>
  </Layout>
);
